import { ACTOR as COMMON_ACTOR } from 'ui-product-approvals-common/constants/actors';

export const ACTOR = {
  ...COMMON_ACTOR,
  TEAM: 'TEAM',
} as const;

export const DEFAULT_AGENT_APPROVER_ID = 'approvals-agent-v0';
